import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { motionTokens } from '@sixui/ui/themes/base/motion.stylex';
import stylex from '@stylexjs/stylex';
import { type LinkProps } from 'react-router-dom';

import type { IContainerProps } from '~/components/utils/Container';
import { getNavigationUrl, LinkBehavior } from '~/components/utils/Navigation';

export type ILinkProps = IContainerProps &
  LinkProps & {
    children?: React.ReactNode;
    to: string;
    noExternalIcon?: boolean;
  };

const styles = stylex.create({
  host: {
    color: colorSchemeTokens.primary,
    textDecoration: {
      default: 'none',
      ':hover': 'underline',
    },
    transitionProperty: 'outline-width',
    transitionDuration: motionTokens.duration$short3,
    transitionTimingFunction: motionTokens.easing$emphasizedDecelerate,
    borderRadius: {
      default: 'unset',
      ':focus': '2px',
    },
    outlineWidth: {
      default: 'unset',
      ':focus': '3px',
    },
    outlineOffset: {
      default: 'unset',
      ':focus': '2px',
    },
    outlineStyle: {
      default: 'none',
      ':focus': 'solid',
    },
    outlineColor: {
      default: 'unset',
      ':focus': colorSchemeTokens.primary,
    },
  },
});

export const Link: React.FC<ILinkProps> = (props) => {
  const { sx, children, noExternalIcon, to: toProp, ...other } = props;

  const to = getNavigationUrl(toProp);

  const isExternal =
    other.target === '_blank' ||
    ['/', '#'].every((prefix) => !to.startsWith(prefix));

  return (
    <LinkBehavior {...stylex.props(styles.host, sx)} href={to} {...other}>
      {children}
      {isExternal && !noExternalIcon ? (
        <>
          {' '}
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
        </>
      ) : null}
    </LinkBehavior>
  );
};
